import {Box, Divider, List, ListItem, ListItemText, Stack, Typography} from "@mui/material";
import SteddiContainer from "../../General/SteddiContainer";
import React from "react";
import Grid2 from "@mui/material/Unstable_Grid2";
import SectionHeader from "../../General/SectionHeader";
import useOrderState from "../../../stores/orderStore";

export default function InitialPage() {
  const steddiPrices = useOrderState((state) => state.steddiPrices)

  return (
    <>
      <Grid2 container spacing={5}>
        <Grid2 xs={12}>
          <SteddiContainer>
            <SectionHeader>Slik fungerer det</SectionHeader>
            <Typography>
              Forutsigbar betaling er en kredittjeneste fra Steddi. Du får fordelt kostnadene dine jevnt over hele året – i stedet for å betale mye om vinteren og lite om sommeren. Før vi går videre,
              får du en oppsummering av tjenesten:
            </Typography>

            <Box sx={{mt: 2}}>
              <SectionHeader isSmol>Priser og forutsetninger</SectionHeader>
              <List sx={{listStyleType: 'disc', ml: 2, pt: 0}}>
                <ListItem sx={{display: 'list-item'}}><ListItemText>Prisen for kredittjenesten er {steddiPrices?.steddiPrice} kr/mnd.</ListItemText></ListItem>
                <ListItem sx={{display: 'list-item'}}><ListItemText>Elektronisk faktura 0 kr. Papirfaktura {steddiPrices?.paperPrice} kr.</ListItemText></ListItem>
              </List>
              <Typography>
                Tjenesten forutsetter godkjent kredittvurdering og at du er privat strømkunde, med samlet årsforbruk på inntil 50.000 kWh hos en av strømleverandørene som Steddi samarbeider med. Du
                kan
                ha inntil tre strømmålere tilknyttet denne tjenesten.
              </Typography>
            </Box>

            <Box sx={{mt: 2}}>
              <SectionHeader isSmol>Et forutsigbart månedsbeløp</SectionHeader>
              <Stack spacing={2}>
                <Typography>
                  Alle kostnadene du har hos strømleverandøren din, blir tatt med i et månedsbeløp du betaler hos Steddi. Dette inkluderer strøm, eventuelt nettleie og tilleggstjenester hvis du pleier
                  å
                  ha dette på strømregningen din.
                </Typography>
                <Typography>
                  Månedsbeløpet ditt vil normalt holde seg likt gjennom året. Det kan justeres hvis det skjer endringer i strømforbruket ditt eller svingninger i strømprisene. Hvis månedsbeløpet ditt
                  endres, blir du varslet om dette.
                </Typography>
                <Typography>
                  Månedsbeløpet ditt er basert på historikk om forbruket fra strømmåleren din og beregninger av strømregningene dine de neste 12 månedene.
                </Typography>
              </Stack>
            </Box>

            <Box sx={{mt: 2}}>
              <SectionHeader isSmol>Saldo og oppsigelse</SectionHeader>
              <Stack spacing={2}>
                <Typography>
                  Du har din egen saldo hos Steddi. Saldoen er balansen mellom det du har betalt inn, og de totale kostnadene på strømregningene dine. Du finner til enhver tid oppdatert saldo i Min
                  side
                  hos strømleverandøren din.
                </Typography>
                <Typography>
                  Du kan fritt avslutte tjenesten med en måneds skriftlig varsel. Da blir saldoen din gjort opp. Ved forsinket betaling av fakturaen, påløper det forsinkelsesrenter og purregebyr.
                </Typography>
              </Stack>
            </Box>

            <Divider sx={{borderColor: "rgba(0, 0, 0, 0.2)", my: 3}}/>
            <Typography sx={{fontSize: "13px", color: "black", lineHeight: "19.5px"}}>
              <b>Effektiv rente</b><br/>
              Det blir ikke belastet rente for kreditten du benytter. Effektiv årlig rente (EÅR) er beregnet i samsvar med finansavtaleforskriften § 1-4. Effektiv rente beregnes med faste gebyrer
              inkludert. Løpetid på kredittavtalen er ubegrenset. For å gi et korrekt bilde er denne beregningen basert på en løpetid på tre måneder, og at det er benyttet et kredittbeløp på 10 000
              kr. Den effektive renten basert på dette er 7,31%.
            </Typography>
          </SteddiContainer>
        </Grid2>
      </Grid2>
    </>
  )
}